import { defineMessages } from 'react-intl'

const scope = 'procurify.expense.component.ExpenseLineItemDrawer'

export default defineMessages({
  addDrawerTitle: {
    id: `${scope}.addDrawerTitle`,
    defaultMessage: 'Add expense line',
  },
  editDrawerTitle: {
    id: `${scope}.editDrawerTitle`,
    defaultMessage: 'Edit expense line',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save',
  },
})
